// React
import { FunctionComponent } from "react";

// Interfaces
import { I_IncidentAction, I_SafetyEvent, I_SafetyEventWithApprovalHistory } from "../../interfaces";

// Services
import VIS from "../../VehicleIncidentsService";

// UI Libraries
import { Button, Modal } from "react-bootstrap";

//constants
import vehicleIncidentsStatusAliases from "../../constants/VehicleIncidentsStatusAliases";

// Local Components
import VehicleIncidentsMiniInfo from "../VehicleIncidentsMiniInfo/VehicleIncidentsMiniInfo";

// Shared Components
import ApprovalHistory from "src/components/approvals/components/ApprovalHistory/ApprovalHistory";

// Styles
import "./VehicleIncidentsApprovalHistory.css";

interface Props {
    incidentAction: I_IncidentAction
}

const VehicleIncidentsApprovalHistory: FunctionComponent<Props> = (props) => {

    const { incidentAction } = props

    const { id } = incidentAction

    const { setIncidentAction, retrieveEventFromMap, isWithApprovalHistory } = VIS

    const event: I_SafetyEvent | I_SafetyEventWithApprovalHistory | null =
        retrieveEventFromMap(id || -1);

    const isNew = !isWithApprovalHistory(event);

    if (isNew || !event) return null

    return (
        <div className="VehicleIncidentsApprovalHistory">
            <Modal
                id="vehicle-incidents-approval-history-modal"
                show
                backdrop="static"
                keyboard
                centered
                className="VehicleIncidentsWorkflowModal"
                animation={false}
            >
                <Modal.Header>
                    <div className="VehicleIncidentsApprovalHistoryModalHeader">
                        <div className="VehicleIncidentsWorkflowModalHeaderUpper">
                            <span className="material-icons">timeline</span>
                            <p>Event History</p>
                        </div>
                        <div className="VehicleIncidentsWorkflowModalHeaderLower">
                            <VehicleIncidentsMiniInfo
                                id={id}
                            />
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className="VehicleIncidentsApprovalHistoryModalBody">
                        <ApprovalHistory
                            history={event.ApprovalHistory}
                            aliasRecord={vehicleIncidentsStatusAliases}
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div className="VehicleIncidentsApprovalHistoryModalFooter">
                        <div className="VehicleIncidentsApprovalHistoryModalFooterLeft" />
                        <div className="VehicleIncidentsApprovalHistoryModalFooterRight">
                            {/* Cancel action resets the incidentAction state */}
                            <Button
                                variant="secondary"
                                onClick={() =>
                                    setIncidentAction({ action: -1, id: -1 })
                                }
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default VehicleIncidentsApprovalHistory;
